import React, { Component } from 'react'
import { Form } from 'antd';
import { Editor } from '@tinymce/tinymce-react';

const FormItem = Form.Item;
class TextEditorCustom extends Component {
    state = {
        plugins: 'autolink lists link image media code fullscreen preview table hr textcolor colorpicker contextmenu',
        toolbar: 'undo redo | formatselect | bold italic backcolor forecolor | image media link unlink table hr | alignleft aligncenter alignright alignjustify bullist numlist outdent indent | preview fullscreen removeformat code',
        editor:null
    }

    render() {
        const { label ,marginBottom="0", labelColor="65", className, ...rest } = this.props;
        return (
            <FormItem label={label} className={`form-label text-editor-custom margin-bottom${marginBottom} label-color${labelColor} ${className ? className : ''}`}>
                <Editor
                    // initialValue={value}
                    { ...rest }
                    init={{
                        menubar: false,
                        height: 200,
                        plugins: this.state.plugins,
                        toolbar: this.state.toolbar,
                        default_link_target: "_blank",
                        //setup: (editor) => this.setState({editor: editor}),
                        //images_upload_url: 'postAcceptor.php',
                        images_upload_handler: function (blobInfo, success, failure) {
                            console.log("test")
                            success()
                        },
                    }}
                    // onChange={this.handleEditorChange}
                    onEditorChange={this.props.handleEditorChange}
                />
            </FormItem>
        )
    }
}


export default TextEditorCustom;
